import { render, staticRenderFns } from "./tnc.vue?vue&type=template&id=a18eb59e&scoped=true&"
import script from "./tnc.vue?vue&type=script&lang=js&"
export * from "./tnc.vue?vue&type=script&lang=js&"
import style0 from "./tnc.vue?vue&type=style&index=0&id=a18eb59e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18eb59e",
  null
  
)

export default component.exports